const enum Services {
  auth = 'auth',
  lk = 'lk',
  ixora = 'ixora',
  collector = 'collector',
  marks = 'marks',
  analytics = 'analytics'
}

const enum Models {
  user = 'user',
  userHistory = 'user-history',
  group = 'group',
  asyncTasks = 'async-tasks',
  permission = 'permission',
  session = 'session',
  formData = 'form-data',
  formTemplate = 'form-template',
  formsHandbook = 'forms-handbook',
  participant = 'participant',
  passport = 'passport',
  profile = 'profile',

  topic = 'topic',
  publication = 'publication',
  publicationStorage = 'publication-storage',
  publicationStorageFile = 'publication-storage-file',
  publicationStorageFileHistory = 'publication-storage-file-history',
  publicationDataCollection = 'publication-data-collection',
  schedulers = 'schedulers',
  file = 'file',
  roadmap = 'roadmap',
  direction = 'direction',
  baseEvent = 'base-event',
  event = 'event',
  notificationBanner ='notification-banner',
  notificationPage ='notification-page',
  munMeh = 'munmeh',
  ixoraView ='ixora-view',
  collectorView = 'collector-view',
  marksView = 'marks-view',
  analyticsClosed = 'analytics-closed',
}

/* eslint max-classes-per-file: 0 */

abstract class PermissionModelBase {
  constructor(
    private readonly service: Services,
    private readonly model: Models,
  ) {}

  protected getModel(type: string) {
    return [
      this.service,
      this.model,
      type,
    ].join(':')
  }
}

class PermissionModelCRUD extends PermissionModelBase {
  public readonly read = this.getModel('read');

  public readonly edit = this.getModel('edit');

  public readonly create = this.edit;

  public readonly delete = this.getModel('delete');
}

class PermissionRoadmap extends PermissionModelCRUD {
  public readonly report = this.getModel('report');

  public readonly review = this.getModel('review');

  public readonly expert = this.getModel('expert');
}

class PermissionMunMeh extends PermissionModelCRUD {
  public readonly expert = this.getModel('expert');
}

class PermissionPassport extends PermissionModelCRUD {
  public readonly list = this.getModel('list');
}

class PermissionAccess extends PermissionModelBase {
  public readonly access = this.getModel('access');
}

export const allPermission = '*'
export const authAsyncTasksPermissions = new PermissionModelCRUD(Services.auth, Models.asyncTasks)
export const authUserPermissions = new PermissionModelCRUD(Services.auth, Models.user)
export const authUserHistoryPermissions = new PermissionModelCRUD(Services.auth, Models.userHistory)
export const authGroupPermissions = new PermissionModelCRUD(Services.auth, Models.group)
export const authPermissionPermissions = new PermissionModelCRUD(Services.auth, Models.permission)
export const authSessionPermissions = new PermissionModelCRUD(Services.auth, Models.session)
export const authFormTemplatePermissions = new PermissionModelCRUD(Services.auth, Models.formTemplate)
export const authFormsHandbookPermissions = new PermissionModelCRUD(Services.auth, Models.formsHandbook)
export const authFormDataPermissions = new PermissionModelCRUD(Services.auth, Models.formData)

export const lkTopicPermissions = new PermissionModelCRUD(Services.lk, Models.topic)
export const lkParticipantPermissions = new PermissionModelCRUD(Services.lk, Models.participant)
export const lkPassportPermissions = new PermissionPassport(Services.lk, Models.passport)
export const lkProfilePermissions = new PermissionModelCRUD(Services.lk, Models.profile)
export const lkPublicationPermissions = new PermissionModelCRUD(Services.lk, Models.publication)
export const lkSchedulers = new PermissionModelCRUD(Services.lk, Models.schedulers)
export const lkPublicationStoragePermissions = new PermissionModelCRUD(Services.lk, Models.publicationStorage)
export const lkPublicationStorageFilePermissions = new PermissionModelCRUD(Services.lk, Models.publicationStorageFile)
// eslint-disable-next-line max-len
export const lkPublicationStorageFileHistoryPermissions = new PermissionModelCRUD(Services.lk, Models.publicationStorageFileHistory)
// eslint-disable-next-line max-len
export const lkPublicationDataCollectionPermissions = new PermissionModelCRUD(Services.lk, Models.publicationDataCollection)
export const lkMunMehPermissions = new PermissionMunMeh(Services.lk, Models.munMeh)

export const lkFilePermissions = new PermissionModelCRUD(Services.lk, Models.file)
export const lkNotificationBannerPermissions = new PermissionModelCRUD(Services.lk, Models.notificationBanner)
export const lkNotificationPagePermissions = new PermissionModelCRUD(Services.lk, Models.notificationPage)
export const lkRoadmapPermissions = new PermissionRoadmap(Services.lk, Models.roadmap)
export const lkRoadmapEventPermissions = new PermissionRoadmap(Services.lk, Models.event)

export const ixoraViewPermissions = new PermissionModelCRUD(Services.ixora, Models.ixoraView)
export const collectorViewPermissions = new PermissionModelCRUD(Services.collector, Models.collectorView)
export const marksViewPermissions = new PermissionModelCRUD(Services.marks, Models.marksView)
export const analyticsClosedPermissions = new PermissionAccess(Services.analytics, Models.analyticsClosed)
